import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  actionConfigOptimizeCfe,
  actionConfigUpdateNumbers,
  actionConfigImportCfe,
  actionConfigGetParameter,
  actionConfigUpdateParameter,
  selectConfigState,
} from "./redux";

import { BUTTON_CONFIG } from "config/constants/Button";
import { Button, ConfirmationModal, Input, ScreenContainer, Text } from "components";

const ACTIONS = {
  UPDATE_NUMBERS: "UPDATE_NUMBERS",
  OPTIMIZE_CFE: "OPTIMIZE_CFE",
  IMPORT_CFE: "IMPORTAR_COMPRAS",
};

const Config = () => {
  const oDispatch = useDispatch();

  const [sAction, setAction] = useState("");
  const [bShowModal, setShowModal] = useState(false);

  const { aParameters } = useSelector(selectConfigState);
  const [sListaXDefecto, setListaXDefecto] = useState("");
  const [sSocGralId, setSocGralId] = useState("");

  const onUpdateNumbers = (bConfirm) => {
    if (!bConfirm) {
      setAction(ACTIONS.UPDATE_NUMBERS);
      return setShowModal(true);
    }
    oDispatch(actionConfigUpdateNumbers());
  };

  const onOptimizeCfe = (bConfirm) => {
    if (!bConfirm) {
      setAction(ACTIONS.OPTIMIZE_CFE);
      return setShowModal(true);
    }
    oDispatch(actionConfigOptimizeCfe());
  };

  const onImportCfe = (bConfirm) => {
    if (!bConfirm) {
      setAction(ACTIONS.IMPORT_CFE);
      return setShowModal(true);
    }
    oDispatch(actionConfigImportCfe());
  };

  const resolveCallback = () => {
    switch (sAction) {
      case ACTIONS.UPDATE_NUMBERS:
        onUpdateNumbers(true);
        break;
      case ACTIONS.OPTIMIZE_CFE:
        onOptimizeCfe(true);
        break;
      case ACTIONS.IMPORT_CFE:
        onImportCfe(true);
        break;
      default:
        break;
    }
    setShowModal(false);
    setAction("");
  };

  const resolveTitle = () => {
    switch (sAction) {
      case ACTIONS.UPDATE_NUMBERS:
        return "Actualizar numeradores";
      case ACTIONS.OPTIMIZE_CFE:
        return "Optimizar tabla de envíos de CFE";
      case ACTIONS.IMPORT_CFE:
        return "Importar compras";
      default:
        return "";
    }
  };

  const resolveQuestion = () => {
    switch (sAction) {
      case ACTIONS.UPDATE_NUMBERS:
        return "Está seguro que desea actualizar los numeradores";
      case ACTIONS.OPTIMIZE_CFE:
        return "Está seguro que desea optimizar la tabla de envíos de CFE";
      case ACTIONS.IMPORT_CFE:
        return "Está seguro que desea importar las compras recibidas";
      default:
        return "";
    }
  };




  useEffect(() => {
    oDispatch(actionConfigGetParameter("ListaXDefecto"));
    oDispatch(actionConfigGetParameter("SocGralId"));
  }, []);

  useEffect(() => {
    const oParam = aParameters.find(p => p.parNom === "ListaXDefecto");
    if (oParam) setListaXDefecto(oParam.parVal);
    const oParamSoc = aParameters.find(p => p.parNom === "SocGralId");
    if (oParamSoc) setSocGralId(oParamSoc.parVal);
  }, [aParameters]);

  const onSaveListaXDefecto = () => {
    oDispatch(actionConfigUpdateParameter({ sName: "ListaXDefecto", sValue: sListaXDefecto }));
  };

  const onSaveSocGralId = () => {
    oDispatch(actionConfigUpdateParameter({ sName: "SocGralId", sValue: sSocGralId }));
  };

  return (
    <ScreenContainer>
      <section className="grid grid-cols-2">
        <Text bold size="text-3xl" color="text-gray-800 dark:text-white" className="self-center">
          Configuración
        </Text>
      </section>
      <section className="flex flex-col gap-5 pt-10">
        <div className="flex items-center border-b-2 py-1">
          <Text bold size="text-xl">Actualizar numeradores:</Text>
          <Button
            label="Actualizar"
            className="ml-auto"
            size={BUTTON_CONFIG.SIZE.SM}
            containerClassName="ml-auto"
            onClick={() => onUpdateNumbers()}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
        <div className="flex items-center border-b-2 py-1">
          <Text bold size="text-xl">Optimizar tabla de envíos de CFE:</Text>
          <Button
            label="Optimizar"
            className="ml-auto"
            size={BUTTON_CONFIG.SIZE.SM}
            containerClassName="ml-auto"
            onClick={() => onOptimizeCfe()}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
        <div className="flex items-center border-b-2 py-1">
          <Text bold size="text-xl">Importar compras pendientes:</Text>
          <Button
            label="Importar"
            className="ml-auto"
            size={BUTTON_CONFIG.SIZE.SM}
            containerClassName="ml-auto"
            onClick={() => onImportCfe()}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
        <div className="flex items-center border-b-2 py-1 gap-5">
          <Text bold size="text-xl">Lista de precios por defecto:</Text>
          <Input
            className="w-40 text-right"
            value={sListaXDefecto}
            onChange={setListaXDefecto}
            placeholder="ID de lista"
          />
          <Button
            label="Guardar"
            size={BUTTON_CONFIG.SIZE.SM}
            containerClassName="ml-auto"
            onClick={onSaveListaXDefecto}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
        <div className="flex items-center border-b-2 py-1 gap-5">
          <Text bold size="text-xl">Socio de negocio por defecto:</Text>
          <Input
            className="w-40 text-right"
            value={sSocGralId}
            onChange={setSocGralId}
            placeholder="ID de socio"
          />
          <Button
            label="Guardar"
            size={BUTTON_CONFIG.SIZE.SM}
            containerClassName="ml-auto"
            onClick={onSaveSocGralId}
            type={BUTTON_CONFIG.CLASS.SUCCESS}
          />
        </div>
      </section>
      <ConfirmationModal
        show={bShowModal}
        title={resolveTitle()}
        onConfirm={resolveCallback}
        question={resolveQuestion()}
        message="Esta acción puede tardar unos minutos"
        onClose={() => { setShowModal(false); setAction(""); }}
      />
    </ScreenContainer>
  );
};

export default Config;
